/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { ReactElement } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  primaryButton: ReactElement;
  secondaryButton: ReactElement;
};

export const ActionButtons: FcWithoutChildren<Props> = (props) => {
  const { primaryButton, secondaryButton } = props;

  return (
    <div css={rootStyle}>
      {primaryButton}

      {secondaryButton}
    </div>
  );
};

const rootStyle = css`
  display: grid;
  row-gap: 12px;
`;
